import { serpStaticAssetsPath } from '@search/core/helpers/constants';
export const addNative = ({ index, ...props }) => ({
    name: `inline${index}`,
    testId: 'serp-inline-ad',
    sizes: [[341, 227], [300, 250], [970, 250], [1000, 250], ['fluid']],
    placeholderPosition: 'initial',
    placeholderMaxWidth: 1000,
    placeholderWidth: '100%',
    placeholderWidthMobile: '100%',
    placeholderHeight: 219,
    placeholderHeightMobile: 375,
    placeholderTop: 10,
    marginVertical: 0,
    marginHorizontal: 'auto',
    ...props,
});
export const addMasthead = (props) => ({
    name: 'mastHead',
    testId: 'serp-mastHead-ad',
    sizes: [[970, 250], [1000, 250], ['fluid']],
    placeholderPosition: 'initial',
    placeholderMaxWidth: 1000,
    placeholderWidth: 'auto',
    placeholderWidthMobile: 'auto',
    placeholderHeight: 250,
    placeholderHeightMobile: 250,
    placeholderTop: 10,
    marginVertical: 0,
    marginHorizontal: 'auto',
    backgroundImage: `${serpStaticAssetsPath}/images/masthead-placeholder.svg`,
    backgroundPosition: 'center',
    ...props,
});
export const addSkyscraperTop = (props) => ({
    name: 'skyscraperTop',
    testId: 'serp-side-skyscraper-top',
    sizes: [
        [300, 600],
        [120, 600],
        [160, 600],
        [200, 600],
        [300, 250],
    ],
    placeholderPosition: 'initial',
    placeholderMaxWidth: 'auto',
    placeholderWidth: 300,
    placeholderWidthMobile: 300,
    placeholderHeight: 600,
    placeholderHeightMobile: 413,
    placeholderTop: 90,
    marginVertical: 0,
    marginHorizontal: 0,
    ...props,
});
export const addSkyscraper = (props) => ({
    name: 'skyscraper',
    testId: 'serp-side-skyscraper',
    sizes: [
        [300, 600],
        [120, 600],
        [160, 600],
        [200, 600],
        [300, 250],
    ],
    placeholderPosition: 'sticky',
    placeholderMaxWidth: 'auto',
    placeholderWidth: 300,
    placeholderWidthMobile: 300,
    placeholderHeight: 600,
    placeholderHeightMobile: 413,
    placeholderTop: 90,
    marginVertical: 0,
    marginHorizontal: 0,
    ...props,
});
export const addBanner = (props) => ({
    name: 'banner',
    testId: 'serp-banner-ad',
    sizes: [[300, 50], [320, 75], [300, 75], [320, 50], ['fluid']],
    placeholderPosition: 'initial',
    placeholderMaxWidth: 'auto',
    placeholderWidth: 320,
    placeholderWidthMobile: 320,
    placeholderHeight: 75,
    placeholderHeightMobile: 75,
    placeholderTop: 10,
    marginVertical: 0,
    marginHorizontal: 'auto',
    ...props,
});
export const addUnderstitial = (props) => ({
    name: 'understitial',
    testId: 'serp-understitial-ad',
    sizes: [
        [320, 480],
        [320, 320],
        [640, 960],
        [640, 640],
    ],
    placeholderPosition: 'initial',
    placeholderMaxWidth: 'auto',
    placeholderWidth: 320,
    placeholderWidthMobile: 320,
    placeholderHeight: 480,
    placeholderHeightMobile: 480,
    placeholderTop: 10,
    marginVertical: 0,
    marginHorizontal: 'auto',
    ...props,
});
